function ModalidadSelector({ value, onChange }) {
  return (
    <div className="tm-reg-modalidad">
      <p className="tm-reg-modalidad-label">¿Cómo deseas aplicar? *</p>
      <div className="tm-reg-modalidad-grid">
        <button
          type="button"
          className={`tm-reg-modalidad-card ${value === 'principal' ? 'is-selected' : ''}`}
          onClick={() => onChange('principal')}
        >
          <span className="material-symbols-outlined tm-reg-modalidad-icon">apartment</span>
          <span className="tm-reg-modalidad-title">Estudio principal</span>
          <span className="tm-reg-modalidad-desc">Presencial en TM Studio</span>
        </button>
        <button
          type="button"
          className={`tm-reg-modalidad-card ${value === 'satelite' ? 'is-selected' : ''}`}
          onClick={() => onChange('satelite')}
        >
          <span className="material-symbols-outlined tm-reg-modalidad-icon">travel_explore</span>
          <span className="tm-reg-modalidad-title">Modalidad satélite</span>
          <span className="tm-reg-modalidad-desc">Trabajo remoto con acompañamiento</span>
        </button>
      </div>
    </div>
  );
}

export default ModalidadSelector;
